export const MAX_FILE_SIZE = 20 * 1000 * 1000
